import { SerializedInventoryMeterReadingGroup } from '@enmon/commons/lib/tools';
import { useAppMessages } from 'hooks/useAppMessages';
import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from 'react-query';
import { ReadingGroupsHooks as messages } from 'routes/reading_groups/messages';
import { UpdateInventoryMeterReadingGroupData } from 'services/api/inventoryMeterReadingGroups';
import { useServices } from 'services/useServices';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export interface UseUpdateInventoryMeterReadingGroupArgs {
  onSuccess?: (group: SerializedInventoryMeterReadingGroup) => void;
  onError?: () => void;
}

export const useUpdateInventoryMeterReadingGroup = ({
  onSuccess,
  onError,
}: UseUpdateInventoryMeterReadingGroupArgs = {}) => {
  const intl = useIntl();
  const {
    api: { inventoryMeterReadingGroupsApiClient },
  } = useServices();
  const queryClient = useQueryClient();
  const appMessages = useAppMessages();

  return useMutation({
    mutationFn: async ({ id, data }: { id: number; data: UpdateInventoryMeterReadingGroupData }) =>
      inventoryMeterReadingGroupsApiClient.update(id, { data }),
    mutationKey: MUTATION_KEYS.inventoryMeterReadingGroups.update(),
    onSuccess: group => {
      appMessages.success(intl.formatMessage(messages.updateGroupSuccess));
      queryClient.invalidateQueries(QUERY_KEYS.inventoryMeterReadingGroups.all());
      onSuccess?.(group);
    },
    onError: () => {
      appMessages.error(intl.formatMessage(messages.updateGroupError));
      onError?.();
    },
  });
};
